import { App } from 'vue'
import vLoadingDirective from './src/loading.ts'
import { ToMsg } from '@touchvue/components'

export default {
	install: (app: App) => {
		ToMsg._context = app
		app.directive('loading', vLoadingDirective)
	},
}

export { vLoadingDirective as vLoading }
